import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/auth.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="auth-root">
      <div className="auth-gradient-bg" />
      <div className="auth-card auth-card-scrollable">
        <button className="auth-back-button" onClick={() => navigate('/')}>
          ← Back to Sign In
        </button>
        <h1 className="auth-title">Terms & Privacy Policy</h1>
        <p className="auth-policy-text">
          This is a demo privacy policy page. Replace this content with your actual terms and privacy
          policy. We recommend clearly explaining what data you collect, how it is used, and how users
          can contact you.
        </p>
        <p className="auth-policy-text">
          By using this application, you agree that your information may be processed for authentication
          and personalization purposes. You should also describe any third-party services integrated in
          your app, such as analytics or social sign-in providers.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;


